import React, { useState } from 'react';
import { useApiQuery } from '../../../../api/hooks';
import { PlusIcon } from '../../model/icons';
import OrgCard from './OrgCard';
import CreateOrgModal from './CreateOrgModal';
import './org.css';

const ORGS_URL = '/api/camps/admin/orgs';

// Страница «Организаторы» (новая верстка): сетка карточек + создание.
export default function OrgPage() {
    const { data: orgList, isLoading, error } = useApiQuery(
        ['org', 'list'],
        ORGS_URL,
        { refetchOnMount: 'always' }
    );

    if (isLoading) return <div className="content white">Загрузка...</div>;
    if (error) return <div className="content white">Ошибка загрузки организаторов</div>;
    if (!orgList) return null;

    return <OrgList initialOrgs={orgList} />;
}

function OrgList({ initialOrgs }) {
    const [orgs, setOrgs] = useState(initialOrgs);
    const [createOpen, setCreateOpen] = useState(false);

    const handleCreated = (org) => setOrgs([...orgs, org]);
    const handleDeleted = (userId) => setOrgs(orgs.filter(o => o.userId !== userId));

    return (
        <section className="content white">
            <div className="org-head">
                <h1>Организаторы</h1>
                <button type="button" className="btn btn-primary" onClick={() => setCreateOpen(true)}>
                    <span className="ic"><PlusIcon /></span>
                    Создать
                </button>
            </div>

            <div className="org-grid">
                {orgs.map(org => (
                    <OrgCard key={org.userId} org={org} onDeleted={handleDeleted} />
                ))}
            </div>

            <CreateOrgModal
                open={createOpen}
                onClose={() => setCreateOpen(false)}
                onCreated={handleCreated}
            />
        </section>
    );
}
